import { MutationTree } from 'vuex';
import {CallSoundsState} from "@/store/call/sounds/types";

export const mutations: MutationTree<CallSoundsState> = {
  setSounds:(state, data) => {
    state.sounds = data
  },
  setSoundItem:(state, data) => {
    state.soundItem = data
  },
  pushSounds:(state, data) => {
    state.sounds = state.sounds.concat(data);
  },
};